import Parse from "parse/dist/parse.min.js";

/*
	Read receipts for the bulk export: exporting delivers the full
	entry content, so every exported entry counts as read -- with the
	same rules as opening one in EntryDetail (createReaders): authors
	are not readers of their own entries, and existing receipts stay
	untouched.
*/

/** The exported entry links the user has not read yet (pure). */
export function collectUnreadEntryLinks(entryLinks, userId) {
	return entryLinks.filter((entryLink) => {
		const entry = entryLink.attributes.entry;
		const author = entry ? entry.attributes.author : undefined;
		if (author && author.id === userId) { return false; }
		const readers = entryLink.attributes.readers || [];
		return !readers.some((reader) => reader.id === userId);
	});
}

/**
 * Add the user to the readers of every exported entry link that they
 * have not read yet. Saved in batches via saveAll; returns the number
 * of links updated.
 */
export async function markEntryLinksRead(entryLinks, user) {
	const unread = collectUnreadEntryLinks(entryLinks, user.id);
	const now = new Date();
	for (const entryLink of unread) {
		// Legacy rows may carry readers without timestamps -- pad with
		// empty arrays instead of spreading undefined.
		entryLink.set("readers",
			[ ...(entryLink.attributes.readers || []), user ]);
		entryLink.set("reader_timestamps",
			[ ...(entryLink.attributes.reader_timestamps || []), now ]);
	}
	if (unread.length > 0) { await Parse.Object.saveAll(unread); }
	return unread.length;
}
